<template>
  <div>
    <nurse-detail
      fetchClinicsBy="franchise"
      :canDelete="true"
      :adminApprovalVar="false"/>
  </div>
</template>

<script>

import nurseDetail from '../../components/nurses/nurseDetail.vue';

export default {
  components: {
      nurseDetail,
  },
  data:()=>({
  }),
};
</script>
